export default __webpack_public_path__ + "static/media/exclametry_bg_gray_up.728fcfa1.svg";